import { Input } from 'almanac-ui/TextInputField/Input'
import { useIsUrlCrawlable } from 'hooks/useIsUrlCrawlable'
import { CharacterLimitNote } from './CharacterLimitNote'
import Styles from './FromURL.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { Heading } from 'blaze-ui/Heading/Heading'

export type FromURLProps = {
  url: string
  onChange: (sampleText: string) => void
  showError: boolean
  autoFocus?: boolean
  children?: React.ReactNode
  isDisabled?: boolean
}

export const FromURL: React.FC<FromURLProps> = ({
  url,
  onChange,
  showError,
  autoFocus = false,
  children,
  isDisabled,
}) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { isValid, errorMessage } = useIsUrlCrawlable(url)
  const { isMobile } = useResponsiveDesign()

  return (
    <div className={Styles.tab}>
      <label htmlFor="from-url">
        {isSystemRedesignEnabled ? (
          <Heading level={3}>Paste a website link you want to use as source material</Heading>
        ) : (
          <Text variant={isMobile ? 'label' : 'largeList'} color={isMobile ? 'var(--dark-80)' : undefined}>
            Paste a website link you want to use as source material
          </Text>
        )}
      </label>
      <div className={Styles.inputContainer}>
        <Input
          value={url}
          onChange={(e) => onChange(e.currentTarget.value)}
          size="lg"
          id="from-url"
          name="sampleText"
          autoFocus={autoFocus}
          autoCapitalize="off"
          placeholder="Enter your website..."
          errorMessage={showError && !url ? 'Required' : errorMessage}
          validMessage={url.length > 0 && isValid ? 'Looks like a valid URL!' : undefined}
          isValid={isValid && !(showError && !url)}
          aria-label="Source website"
          disabled={isDisabled}
        />
        {isSystemRedesignEnabled && <CharacterLimitNote />}
      </div>
      {children}
      {!isSystemRedesignEnabled && <CharacterLimitNote />}
    </div>
  )
}
